<template>
  <div>
    <loading :loading="isLoading">
      <b-card header="Related extract data">
        <error :error="error"/>
        <div v-if="page">
          <b-list-group flush>
            <b-list-group-item>
              <discounts :discounts="page.Discounts"/>
            </b-list-group-item>
            <b-list-group-item>
              <shbe :shbe="page.Shbe"/>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-card>
    </loading>
  </div>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'
import Discounts from '../extract_views/Discounts.vue'
import Shbe from '../extract_views/Shbe.vue'

export default {
  components: { Loading, Error, Discounts, Shbe },
  props: ['reference'],
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'empty_house_council_tax',
      parameters: {
        reference: this.reference,
      },
    })
    .then((page) => { this.page = page; this.isLoading = false; })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  }
}
</script>
